<div #dropdownElement class="with-filter-dropdown w-100 h-100" [attr.data-test-id]="testId">
  <div
    class="font--xxl-13 w-100 font-regular cursor-pointer flex align-items-center overflow-hidden one-line-text"
    (click)="isOpen = !isOpen"
    [ngClass]="{
      'color-dark-blue ': selectedItem,
      'color-body-text': !selectedItem,
      'border-blue-button': isOpen || selectedItem,
      box: dropDownType === dropDownTypeEnum.box,
      simple: dropDownType === dropDownTypeEnum.simple,
      filled: !!selectedItem
    }"
  >
    <p
      style="color: inherit; font-size: inherit; font-weight: inherit"
      class="input-text flex align-items-center overflow-hidden wrap--1-line"
    >
      {{ selectedItem?.title || selectedItem || placeholderValue }}
    </p>
    <img
      *ngIf="dropDownType === dropDownTypeEnum.simple"
      src="/assets/images/icons/{{ icon }}{{ isOpen ? '-active' : '' }}.svg"
      style="max-height: 1.5rem"
      [ngClass]="{ expand: isOpen }"
      alt=""
    />
    <img
      *ngIf="dropDownType === dropDownTypeEnum.box"
      src="/assets/images/icons/{{ icon }}-down.svg"
      style="max-height: 1.5rem; max-width: 1.5rem"
      [ngClass]="{ expand: isOpen }"
      alt=""
    />
  </div>

  <div *ngIf="isOpen" class="filter-dropdown overflow-y--scroll">
    <div
      class="flex align-items-center cursor-pointer padding-xxl--left-12 padding-xxl--right-12"
      *ngFor="let item of clonedItems"
      [ngClass]="{
        'background-stroke': item.value === selectedItem?.value
      }"
      (click)="selectItem(item)"
    >
      <div *ngIf="withCircle" class="circle margin-xxl--right-5 {{ item.circleColor }}"></div>
      <p
        class="font--xxl-13 font-regular"
        [ngClass]="{
          'color-dark-blue': item.value === selectedItem?.value,
          'color-body-text': item.value !== selectedItem?.value
        }"
      >
        {{ item.title }}
      </p>
    </div>
  </div>
</div>
